import React from "react";
import { formatINR } from "../data/dummyLedgerTransactionsData";
import { FaArrowUp, FaArrowDown, FaBalanceScale } from "react-icons/fa";

export default function LedgerTransactionCards({
  monthLabel = "",
  totalDebit = 0,
  totalCredit = 0,
  closingBalance = 0,
  closingType = "Dr",
}) {
  const isClCr = closingType === "Cr";

  return (
    <div className="lt_kpi_row">
      {/* 1. Total Debit */}
      <div className="lt_kpi_card">
        <div className="lt_kpi_icon_box icon_debit">
          <FaArrowUp />
        </div>
        <div className="lt_kpi_content">
          <span className="lt_kpi_label">Total Debit ({monthLabel})</span>
          <span className="lt_kpi_value">
            ₹ {formatINR(totalDebit)}
          </span>
        </div>
      </div>

      {/* 2. Total Credit */}
      <div className="lt_kpi_card">
        <div className="lt_kpi_icon_box icon_credit">
          <FaArrowDown />
        </div>
        <div className="lt_kpi_content">
          <span className="lt_kpi_label">Total Credit ({monthLabel})</span>
          <span className="lt_kpi_value">
            ₹ {formatINR(totalCredit)}
          </span>
        </div>
      </div>

      {/* 3. Closing Balance */}
      <div className="lt_kpi_card">
        <div className="lt_kpi_icon_box icon_closing">
          <FaBalanceScale />
        </div>
        <div className="lt_kpi_content">
          <span className="lt_kpi_label">Closing Balance ({monthLabel})</span>
          <span className="lt_kpi_value">
            ₹ {formatINR(closingBalance)}
            <span className={isClCr ? "drcr_text_cr" : "drcr_text_dr"}>
              {closingType}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}
